import React, { useEffect, useState } from 'react'
import WellnessStore from '../DataRepo/WellnessStore'
import { IconButton, CircularProgress, Autocomplete, TextField, Tabs, Tab } from '@mui/material';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import loadingimg from '../Assets/images/loading image 1.png'
import { useLocation, useNavigate } from 'react-router-dom';

function ArticlesPage() {

    const { Articles, getArticles, isArticlesLoading } = WellnessStore()

    const navigate = useNavigate();

    const [searchTerm, setSearchTerm] = useState('');

    const location = useLocation();

    const { categoryName } = location.state || {};

    const [value, setValue] = useState(0);

    const predefinedOrder = [
        'Energy & Weight issues',
        'Gut & Digestive Wellness',
        "Stress, Sleep & Mental Wellness",
        "Hormonal, Men & Women's Wellness",
        "Joint & Muscle Wellness",
        "Skin & Hair wellness",
        "Respiratory & Immune Wellness",
        "Prakriti series",
        "Longevity series",
    ];

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleSearchChange = (event, newValue) => {
        setSearchTerm(newValue || '');
    };

    useEffect(() => {
        const index = predefinedOrder.findIndex(category => category.includes(categoryName));

        if (index !== -1) {
            setValue(index);
        } else {
            setValue(0);
        }

    }, [location]);

    useEffect(() => {
        getArticles()
    }, [])

    useEffect(() => {

        const normalizedSearch = searchTerm.toLowerCase();

        const index = predefinedOrder.findIndex(category => category?.toLowerCase()?.includes(normalizedSearch));

        if (index !== -1 && normalizedSearch) {
            setValue(index);
        }



    }, [searchTerm])

    const filteredArticles = Articles?.filter((e) => {

        const normalizedTitle = e.title?.toLowerCase();
        const normalizedCategory = e.category?.toLowerCase();
        const normalizedSearch = searchTerm?.toLowerCase();

        if (searchTerm.trim()) {
            return (
                normalizedTitle?.includes(normalizedSearch) ||
                normalizedCategory?.includes(normalizedSearch)
            );
        }


        return e.category === predefinedOrder[value];
    });

    const handleNavigateToArticle = (articleUrl) => {
        navigate("/ViewArticle", { state: { url: articleUrl } });
    };


    console.log(categoryName)

    return <div className='All-products-section-main'>
        <nav className='flex flex-row p-2 items-center justify-between'>
            <div className='flex flex-row items-center'>
                <IconButton onClick={() => navigate(-1)}>
                    <ChevronLeft />
                </IconButton>
                <p className='mb-0'>Articles</p>
            </div>
        </nav>

        {isArticlesLoading ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: '100vh' }}>
            <div style={{ position: "relative", width: "10rem", height: "10rem" }}>
                <CircularProgress style={{ width: "100%", height: "100%", color: "#DA6E0B" }} thickness={1} />
                <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <img src={loadingimg} style={{ width: "80%", height: "80%" }} alt="Loading" />
                </div>
            </div>
        </div> :
            <div className='Diet-recommendation-page'>
                <div className="my-4">
                    <Autocomplete
                        freeSolo
                        options={
                            [...new Set(
                                Articles?.flatMap((e) => [e?.title, e?.category])
                            )].filter(Boolean) // Remove undefined/null
                        }
                        getOptionLabel={(option) => option || ''} // Explicit label getter
                        onInputChange={(e, newValue) => setSearchTerm(newValue)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Search articles"
                                variant="outlined"
                                className="w-full"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#DA6E0B',
                                        },
                                    },
                                }}
                            />
                        )}
                    />

                </div>

                <Tabs
                    value={value}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                        '& .MuiTabs-indicator': {
                            display: 'none',
                        },
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            padding: '5px',
                            borderRadius: '4px',
                            fontFamily: "'Poppins', sans-serif",
                            fontSize: "13px",
                            fontWeight: 500,
                            border: '1px solid #ccc',
                            margin: '0 4px',
                            minWidth: 0,
                            minHeight: 0,
                            backgroundColor: '#D4CEC3',
                            color: "#3B362A",
                            '&.Mui-selected': {
                                backgroundColor: '#75623F',
                                color: '#FFFFFF',
                            },
                        },
                    }}
                >
                    {predefinedOrder.map((category, index) => (
                        <Tab key={category} label={category} />
                    ))}

                </Tabs>

                <div className="list-of-articles grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6">
                    {filteredArticles && filteredArticles.length > 0 ? (
                        filteredArticles?.map((e, i) => (
                            <div
                                key={i}
                                onClick={() => { handleNavigateToArticle(e?.src) }}
                                className="articles-card bg-white rounded-xl shadow-md overflow-hidden transition-transform transform hover:scale-105"
                                style={{
                                    cursor: "pointer"
                                }}
                            >
                                <div className="h-50 w-full overflow-hidden">
                                    <img src={e?.image} alt={e?.title} className="object-cover h-full w-full" />
                                </div>
                                <div className="p-4">
                                    <p className="text-lg text-[#3B362A]" style={{
                                        fontFamily: "'Poppins', sans-serif",
                                        fontWeight: 500,
                                        color: "#3B362A"
                                    }}>{e?.title}</p>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="col-span-full text-center text-gray-500">No Articles Found</div>
                    )}
                </div>
            </div>
        }
    </div>
}

export default ArticlesPage
